"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgPersonalHelp(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M5 36.04S5.161 31 9.559 31h6.92c4.086 0 4.467 5.04 4.467 5.04", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M13.2 27.4a4.2 4.2 0 100-8.4 4.2 4.2 0 000 8.4z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M27 5a8 8 0 100 16 8 8 0 000-16", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M25 10.668S25 9 27.069 9c2.068 0 2.356 1.721 1.427 2.41-.602.447-1.496.923-1.496.923V14", stroke: "currentColor", strokeWidth: 1.657, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M27 18a1 1 0 100-2 1 1 0 000 2z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgPersonalHelp;
//# sourceMappingURL=PersonalHelp.js.map